// removed by extract-text-webpack-plugin
module.exports = {"smallScreen":"400px","mediumScreen":"900px","largeScreen":"1200px","xlargeScreen":"1500px"};


//////////////////
// WEBPACK FOOTER
// ./assets/scss/style.scss
// module id = 6
// module chunks = 1